// src/utils/auth.ts
/* eslint-disable @typescript-eslint/no-explicit-any */

// If you have RootState, use it instead of `any`.
type Rootish = any;

/** Read from Redux in a resilient way (your login slice shape). */
export const selectIsAuthed = (s: Rootish): boolean => {
  const login = s?.login ?? {};
  // primary: token in slice
  if (login?.token?.access) return true;
  // secondary: user object in slice
  if (login?.user) return true;
  // some apps also keep a boolean
  if (login?.isAuthenticated === true) return true;
  return false;
};

/** Safe localStorage read (client-only). */
export const hasStoredAccess = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const t = localStorage.getItem('accessToken');
    return !!t && t !== 'null' && t !== 'undefined';
  } catch {
    return false;
  }
};

/** Optional non-sensitive cookie hint (UI only, no secrets). */
export const getAuthHintCookie = (): boolean => {
  if (typeof document === 'undefined') return false;
  return /(?:^|;)\s*auth_hint=1(?:;|$)/.test(document.cookie);
};
export const setAuthHintCookie = (on: boolean) => {
  if (typeof document === 'undefined') return;
  // keep it simple; adjust domain/path as needed
  document.cookie = `auth_hint=${on ? '1' : '0'}; Path=/; SameSite=Lax`;
};

/** One-liner: am I logged in (Redux → storage → hint)? */
export const quickIsAuthed = (state?: Rootish): boolean => {
  if (state && selectIsAuthed(state)) return true;
  if (hasStoredAccess()) return true;
  if (getAuthHintCookie()) return true;
  return false;
};
